export default __webpack_public_path__ + "static/media/parceiros.ed0ae198.jpeg";